<div class="overlay">
  <div class="text">
    {state.questions[vars.scope]}
  </div>
  <div class="options">
    <div>
      <button><a target="_blank" href="https://www.tieto.com/en/careers/search-our-jobs/?area=&amp;country=Latvia&amp;city=&amp;q=">Check our opportunities!</a></button>
      <button on:click={learnMore}>Learn more why there’s no workplace like TietoEVRY!</button>    
    </div>
    <div>
      <button class="again" on:click>Try again?</button>
    </div>
  </div>
</div>

<style type="text/scss">
@import '../sass/breakpoints';

.overlay{
  position:absolute;
  top:0px; left:0px;
  width:100%; height:100%;
  background-color:#000000CD;
  display:flex;
  flex-direction:column;
  justify-content:space-around;
  align-items:center;  
  .text{
    font-size:34px;
    letter-spacing:-0.41px;
    font-weight:700;
    margin:0px 100px;
    text-align:center;
    margin-top:0px;
  }
  .options{
    width:70%;

    & > div{
      display:flex;
      flex-direction:row;
      justify-content:center;   
      
    }


    button{
      width:33%;
      background-color:var(--secondary);
      border:2px solid var(--secondary);
      border-radius:0;
      margin:10px;
      position:relative;
      margin-bottom:100px;
      
      &.again{
        border:2px solid #62b757;
        background-color:transparent;
        border-radius:0;
        color:white;
        padding:20px;
      }

      a{
        color:white;
        width:100%; display:block;
        position:absolute;
        top:0px; left:0px; height:100%;
        display:flex;
        justify-content:center;
        align-items:center;
        &:hover{
          text-decoration:none;
        }
      }
      &:hover{
        background-color:var(--success);
        border:2px solid var(--success);
        &:before{
          background-color:var(--success);
          border:2px solid var(--success);
        }
      }
    }
  }
}

@media #{$mobile-landscape}{
  .overlay{
    .text{
      font-size:20px;
    }
    .options{
      width:100%;
      button{
        font-size:14px;
        width:100%;
        margin:10px;
        padding:10px 20px;

        &.again{
          width:50%;
          padding:10px 0px;
        }
      }
    }
  }
}
</style>

<script>
import { section } from '../stores/navigation'

export let state
export let vars

const sendCV = () => {
  window.open(this.href)
}
const learnMore = () => {  
  setTimeout( () => { window.scrollTo({ top:window.innerHeight+50, behavior: 'smooth' }) } , 100 )  
  section.set('expand',true)
}
</script>